import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardContent, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

// 이름만 있을 때의 안전한 크레딧 판별용 (백업)
const TWO_CREDIT_COURSES = ['로봇명사와의만남', '지능형로봇의이해', 'IntroductiontoIntelligentRobotics'];

function SubjectCard({ title, courseId, credit, currentModule, selected, addLecture, isSelectable, dense = false }) {
  const [open, setOpen] = useState(false);
  const lectureCredit = useMemo(() => (typeof credit === 'number' ? credit : TWO_CREDIT_COURSES.includes(title) ? 2 : 3), [credit, title]);

  // 현재 카드가 선택되어 있는지(선택 상태는 상위 selected에서 유도)
  const isSelected = useMemo(
    () => (selected.selectedLectures || []).some((lec) => lec && lec.courseId === courseId),
    [selected.selectedLectures, courseId]
  );

  useEffect(() => {
    // 모듈 스위칭 시 카드 자체에서 할 로직은 없음 (상위에서 상태 재구성)
  }, [selected.module]);

  const handleConfirm = () => {
    setOpen(false);
    addLecture({
      selectedLectures: [{ courseId, courseName: title }],
      module: currentModule,
      changed: !selected.changed,
      credit: lectureCredit
    });
  };

  const handleClose = () => setOpen(false);

  const handleCardClick = () => {
    if (!isSelectable) {
      // eslint-disable-next-line no-alert
      alert('이 교과목은 현재 모듈에 활용할 수 없습니다.');
      return;
    }

    // 다른 모듈에서 선택 중이면 확인
    if (selected.module !== '' && currentModule !== selected.module) {
      setOpen(true);
      return;
    }

    // 동일 모듈 내 토글
    if (!isSelected) {
      // 추가
      if (selected.credit + lectureCredit > 13) {
        // eslint-disable-next-line no-alert
        alert('학점은 13학점을 초과할 수 없습니다');
        return;
      }
      addLecture((prev) => ({
        ...prev,
        module: currentModule,
        selectedLectures: [...prev.selectedLectures, { courseId, courseName: title }],
        credit: prev.credit + lectureCredit
      }));
    } else {
      // 제거
      addLecture((prev) => {
        const nextLectures = prev.selectedLectures.filter((lec) => lec.courseId !== courseId);
        const nextCredit = prev.credit - lectureCredit;
        return nextCredit
          ? { ...prev, selectedLectures: nextLectures, credit: nextCredit }
          : { selectedLectures: [], module: '', changed: false, credit: 0 };
      });
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'다른 모듈의 과목을 선택하시나요?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            다른 모듈 과목을 선택하면 기존 모듈에서 선택했던 과목이 취소됩니다. 계속 진행하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} autoFocus>
            예
          </Button>
          <Button onClick={handleClose}>아니오</Button>
        </DialogActions>
      </Dialog>

      <Card
        onClick={isSelectable ? handleCardClick : undefined}
        sx={{
          backgroundColor: isSelectable ? (isSelected ? 'primary.main' : 'white') : 'grey.300',
          color: isSelectable ? (isSelected ? 'white' : 'black') : 'grey.500',
          cursor: isSelectable ? 'pointer' : 'default',
          opacity: isSelectable ? 1 : 0.6,
          '& .MuiCardContent-root': {
            py: dense ? 0.5 : 1,
            px: dense ? 1 : 1.5
          }
        }}
      >
        <CardContent>
          <Typography variant={dense ? 'body2' : 'body1'} component="div">
            {title}
            {!isSelectable && (
              <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                (선택 불가)
              </Typography>
            )}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}

export default SubjectCard;
